import { TableCell } from '@material-ui/core';
import styled, { css } from 'styled-components';
import Button from '../../../../../../components/Button';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;

  padding: 12px 16px 16px;

  @media (min-width: 768px) {
    padding: 16px 20px 20px;
  }

  @media (min-width: 1024px) {
    padding: 20px 24px 24px;
  }

  h1 {
    font-weight: 700;
    font-size: 24px;
    color: #263238;
    margin-top: 12px;
  }

  p.description {
    color: #757575;
    font-size: 14px;
    font-weight: 300;
    margin: 4px 0 16px;
  }

  div.activation__container {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  div.list__services {
    margin: 16px 0px;

    @media (min-width: 768px) {
      margin: 20px 0px;
    }

    @media (min-width: 1024px) {
      margin: 24px 0px;
    }
  }
`;

export const ButtonSubmit = styled(Button)`
  max-width: 300px;
  margin: 0 auto;
  margin-top: 16px;

  @media (min-width: 768px) {
    margin-top: 20px;
  }

  @media (min-width: 1024px) {
    margin-top: 24px;
  }
`;

export const StatusSaleButton = styled.button<{ isPaused: boolean }>`
  padding: 4px 8px;

  font-size: 12px;

  border: 1px solid #bdbdbd;
  background: #eee;
  color: #757575;

  transition: all 0.35s ease-in-out;

  &.activated {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  &.paused {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    border-right: none;
  }

  ${(props) =>
    !props.isPaused &&
    css`
      color: #fff;
      font-weight: 500;

      &.paused {
        background: #d32f2f;
        border: 1px solid #c62828;

        &:hover {
          background: #c62828;
          border-color: #b71c1c;
        }
      }

      &.activated {
        background: #1976d2;
        border: 1px solid #1565c0;

        &:hover {
          background: #1565c0;
          border-color: #0d47a1;
        }
      }
    `}

  ${(props) =>
    props.isPaused &&
    css`
      &:hover {
        background: #e0e0e0;
        border-color: #9e9e9e;
      }
    `}
`;

export const CustomTableCell = styled(TableCell)`
  img {
    max-height: 20px;
  }

  p {
    white-space: nowrap;
  }
`;
